<template>
  <div class="poster-container">
    <div class="poster" id="poster">
      <img class="bg" :src="randomImage" alt="" />
      <div class="user-info">
        <div class="user-container">
          <img class="avatar" :src="info.image" alt="" />
          <div
            >我是第<span class="num">{{ info.project_id }}</span
            >位Project挑战者</div
          >
        </div>
        <div class="title">正在挑战</div>
        <div class="title"
          ><span class="num">30</span><span>天内</span
          ><span class="type-text"
            >{{ challengeType }}<span class="num">{{ info.target }}</span
            >{{ lessUnit }}</span
          ></div
        >
      </div>
      <div class="qrcde">
        <canvas id="qrcode-canvas" ref="qrcode"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { goalData } from '../data.js'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      posterList: [
        'https://cdnvue.gymcity.com.cn/uploads/7015254aeefd6fdd2c373aee8bd353e3.png',
        'https://cdnvue.gymcity.com.cn/uploads/8110bcbfd2fd42bef23e6d425c78d122.png',
        'https://cdnvue.gymcity.com.cn/uploads/5d72f2ebeb16197e5af1d78c7a93a2a8.png'
      ],
      qrcodeUrl: '',
      goalData: goalData,
      randomImage: ''
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.init()
      }
    }
  },
  computed: {
    //挑战类型
    challengeType() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.text || ''
      )
    },
    lessUnit() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.unit || ''
      )
    }
  },
  created() {
    // this.init();
    this.setQrcode()
  },
  methods: {
    setQrcode() {
      let qrcode
      let fid = this.info.uid
      let env = this.$http.curEv()
      if (env === 'pro') {
        qrcode = `https://vue.gymcity.com.cn/?path=acceptrecommend&fid=${fid}&s_from=activityProject&scope=snsapi_userinfo`
      } else {
        qrcode = `https://test.gymcity.com.cn/?path=acceptrecommend&fid=${fid}&s_from=activityProject&scope=snsapi_userinfo`
      }
      this.qrcodeUrl = qrcode
    },
    init() {
      //随机海报图片
      let index = Math.floor(Math.random() * this.posterList.length)
      this.randomImage = this.posterList[index]
      this.$nextTick(() => {
        this.createQrcode()
      })
    },
    createQrcode() {
      this.$toast.loading('生成二维码中')
      //计算出二维码的实际宽度
      let screenWidth = window.screen.width
      let designWidth = 375
      let designQrcodeWidth = 75
      let qrcodeWidth = (screenWidth * designQrcodeWidth) / designWidth
      // 合成分享图
      let canvas = this.$refs.qrcode
      QRCode.toCanvas(
        canvas,
        this.qrcodeUrl,
        { width: qrcodeWidth, height: qrcodeWidth },
        (error) => {
          if (error) {
            console.log(error)
            this.$toast.clear()
            this.$toast('生成二维码失败')
            this.$emit('fail')
          } else {
            this.$nextTick(() => {
              this.$emit('finish')
            })
          }
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-container {
  opacity: 0;
  position: fixed;
  width: 100%;
  left: 0;
  transform: translate(3000%, -50%);
  top: 50%;
  z-index: 999;
  width: 375px;
  height: 720px;
}

.poster {
  position: relative;
  width: 100%;
  height: 100%;

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: contain;
  }

  .user-info {
    position: absolute;
    left: 50%;
    top: 87px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 10px 0px 20px;
    left: 50%;
    transform: translate(-50%);
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;

    .user-container {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      margin-bottom: 33px;

      .avatar {
        border-radius: 50%;
        width: 34px;
        height: 34px;
        box-sizing: border-box;
        border: 1px solid #ffffff;
        margin-right: 10px;
      }

      .num {
        font-family: DIN;
        font-weight: bold;
        font-size: 36px;
        color: #cbffb6;
        line-height: 24px;
      }
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 26px;
      color: #ffffff;
      display: flex;
      align-items: center;
      margin-bottom: 11px;

      .num {
        font-family: DIN;
        font-weight: bold;
        font-size: 32px;
      }

      .type-text {
        color: #cbffb6;
      }
    }
  }

  .qrcde {
    position: absolute;
    right: 20px;
    bottom: 23px;
    width: 75px;
    height: 75px;
  }
}
</style>
